import { Injectable, inject } from '@angular/core';

import { Actions } from '@ngrx/effects';
import { map, mergeMap } from 'rxjs/operators';

import { createEffectFactory } from '@core/ngrx-legacy';

import { RegionActions } from './regions.store';
import { RegionsHttpClient } from './regions.types';

@Injectable({ providedIn: 'root' })
export class RegionEffects {
  private readonly regionsHttpClient = inject(RegionsHttpClient);
  private readonly actions$ = inject(Actions);

  public effects = createEffectFactory(RegionActions, this.actions$);

  public fetchRegions$ = this.effects(
    RegionActions.fetchOne,
    ({ payload }) =>
      this.regionsHttpClient
        .fetchRegions(payload.id.toString())
        .pipe(map(regions => ({ data: { id: payload.id.toString(), regions } }))),
    { customMapOperator: mergeMap },
  );
}
